// src/data/juzMeta.js
// Where each of the 30 juz begins, as [surah, ayah]. Mirrors JUZ_STARTS in the metadata service.

export const JUZ_STARTS = [
  [1, 1], [2, 142], [2, 253], [3, 93], [4, 24], [4, 148], [5, 82], [6, 111], [7, 88], [8, 41],
  [9, 93], [11, 6], [12, 53], [15, 1], [17, 1], [18, 75], [21, 1], [23, 1], [25, 21], [27, 56],
  [29, 46], [33, 31], [36, 28], [39, 32], [41, 47], [46, 1], [51, 31], [58, 1], [67, 1], [78, 1],
];

export const juzList = JUZ_STARTS.map(([surah, ayah], index) => ({ id: index + 1, surah, ayah }));

/**
 * The juz an ayah belongs to.
 */
export const juzOf = (surah, ayah) => {
  let juz = 1;
  JUZ_STARTS.forEach(([s, a], index) => {
    if (surah > s || (surah === s && ayah >= a)) juz = index + 1;
  });
  return juz;
};
